var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"back",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":_vm.svgWithColor,"alt":"Ícone de voltar"}}),_vm._v("\n  Carteira de pesca\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }